import React from 'react';

function LoadingModal() {
 // const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative flex items-center justify-center h-screen">
      {/* <button 
        onClick={() => setIsOpen(true)}
        className="px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
      >
        Calcular precio
      </button> */}

      {/* {isOpen && ( */}
        <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25">
          <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
            <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
            <p className="mt-4 text-lg">El precio de los honorarios</p>
            <p className=" text-lg">se está calculando de nuevo</p>
            {/* <button 
              onClick={() => setIsOpen(false)}
              className="px-4 mt-4 font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
            >
              Cerrar
            </button> */}
          </div>
        </div>
      {/* )} */}
    </div>
  );
}

export default LoadingModal;
